import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WebUserInfo } from '../data/web-user-info';
import { WebOrderLocationSetup } from '../Model/web-order-location-setup';
import { ApiFactoryEndPoints } from '../common/api-factory-end-points';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContactService {


  constructor(
    private http: HttpClient,
    private apiFactory: ApiFactoryEndPoints,
  ) { }

  saveWebUserInfo(url: string, webUserInfo: WebUserInfo) {
    return this.http.post<any>(url, webUserInfo);
  }

  getVisitorCount(api: string, url: string, type: string) {
    return this.http.get(api + "/" + url + "/" + type, {
      responseType: "json",
    });
  }

  getLocationDetailsByPincodeAndlatlng(pincode: number, currentUrl: string, latitude?: number, longitude?: number): Observable<any> {
    return this.http.get<WebOrderLocationSetup>(this.apiFactory.getWebOrderLocationDetails + "/" + pincode + "/" + currentUrl + "/" + latitude + "/" + longitude);
  }
}
